"use strict";

const _ = require('lodash');
const d3 = require('d3');
const BasicChart = require('./basic');
const legendMixin = require('./legend').legendMixin;
const layeredMixin = require('./layered').layeredMixin;

class StackedBarsChart extends BasicChart.plug(legendMixin, layeredMixin) {
	constructor(options) {
		super(options);
		_.bindAll(this, 'setBar', 'setInteractBar');
	}

	setBar(selection) {}

	drawChart(selection) {
		this._chart = selection;
		let self = this;
		let data = this.data;
		let xScale = this.xScale;
		let yScale = this.yScale;
		let barWidth = xScale.bandwidth();
		let layers = this.layers;

		let stack = d3.stack()
			.keys(layers)
			.value(function (d, key) {
				return d[key] || 0;
			})
			.order(d3.stackOrderNone).offset(d3.stackOffsetNone);

		let layer = selection.selectAll('g.layer')
			.data(stack(data)).enter().append('g')
			.attr('class', function (d, i) {
				var index = self.layerColourIndex(layers[i]);
				return `layer zl-cc-fill-${index}`;
			});

		layer.selectAll("rect")
			.data(_.identity).enter()
			.append('rect')
			.attr('x', function(d, i) {
				return xScale(self.getX(d.data, i));
			})
			.attr('y',  function (d) {
				return yScale(d[1]);
			})
			.attr('height', function (d) {
				return yScale(d[0]) - yScale(d[1]);
			})
			.attr('width', barWidth)
			.call(this.setBar);
		return this._chart;
	}

	setInteractBar(selection) {
		selection.classed('interact bar', true);
	}

	drawInteract(selector) {
		let self = this;
		let height = this.options.innerHeight;
		let xScale = this.xScale;
		let barWidth = xScale.bandwidth();
		let legend = this.legend;

		return selector.selectAll('.interact.bar').data(this.data).enter()
			.append('rect')
			.attr('width', barWidth).attr('height', height)
			.attr('x', function (d, i) {
				return xScale(self.getX(d, i));
			})
			.call(this.setInteractBar)
			.on('mouseover', function (d, i) {
				legend.show({node: this, data: d});
				d3.select(this).classed('highlight', true);
				self.emit('cm:interact', d);
			})
			.on('mouseout', function (d, i) {
				legend.hide();
				d3.select(this).classed('highlight', false);
				self.emit('cm:interact');
			});
	}

	draw(options) {
		super.draw(options);
		var interact = this._interact = this.canvas.append('g');
		this.drawInteract(interact);
	}
}

module.exports = StackedBarsChart;